'use client';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Focusable } from '@s7/base';
import { useDisclosure } from '@s7/hooks';
import { Stack, Flex } from '@s7/layout';
import { packSX, rem } from '@s7/styles';
import { Button, Typography, SwipeableDrawer } from '@s7/ui';
import { useAnalytics } from '../../analytics.js';
import { langButtonStyles, langWrapperStyles, langItemStyles } from './HeaderLanguage.styles.js';
import { useShadowStyle } from '../../hooks/useShadowStyle/useShadowStyle.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const HeaderLanguage = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { sx, value = 'ru', data, title = 'Выберите язык', onChange, onClick } = props, others = _object_without_properties_loose(props, [
        "sx",
        "value",
        "data",
        "title",
        "onChange",
        "onClick"
    ]);
    const shadowStyle = useShadowStyle();
    const [opened, { open, close }] = useDisclosure(false);
    const headerTopic = useAnalytics('header');
    const handleClick = (language)=>()=>{
            onChange == null ? void 0 : onChange(language.code);
            headerTopic.chooseLang(language.code);
            close();
        };
    const handleOpen = (event)=>{
        open();
        headerTopic.goChooseLang();
        onClick == null ? void 0 : onClick(event);
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Button, _extends({
                ref: ref,
                "aria-label": "language",
                sx: [
                    langButtonStyles,
                    shadowStyle,
                    ...packSX(sx)
                ],
                variant: "white",
                onClick: handleOpen
            }, others, {
                children: /*#__PURE__*/ jsx(Typography, {
                    color: "text.primary",
                    size: "xs2",
                    variant: "text",
                    weight: "semibold",
                    children: value.toUpperCase()
                })
            })),
            /*#__PURE__*/ jsx(SwipeableDrawer, {
                styles: {
                    body: {
                        padding: rem('0 16 24')
                    }
                },
                opened: opened,
                snapPoint: "auto",
                title: title,
                onClose: close,
                children: /*#__PURE__*/ jsx(Stack, {
                    spacing: 0,
                    sx: langWrapperStyles,
                    children: data == null ? void 0 : data.map((language)=> {
                        var _language_icon;
                        return jsx(Focusable, {
                            sx: {
                                width: '100%'
                            },
                            children: /*#__PURE__*/ jsxs(Flex, {
                                align: "center",
                                spacing: "2.5s",
                                sx: langItemStyles,
                                onClick: handleClick(language),
                                children: [
                                    (_language_icon = language.icon) != null ? _language_icon : null,
                                    /*#__PURE__*/ jsx(Typography, {
                                        size: "sm1",
                                        children: language.label
                                    })
                                ]
                            })
                        }, language.code);
                    })
                })
            })
        ]
    });
});

export { HeaderLanguage };
//# sourceMappingURL=HeaderLanguage.js.map
